import styled, { css } from "styled-components";
import { Paper } from "@commonlibs";
import { alpha } from "@commonlibs";

export const CalloutRoot = styled(Paper)(
    ({ theme }) => css`
        &&& {
            width: 100%;
            padding: ${theme.spacing.all(2.5, 3)};
            border-radius: ${theme.borderRadius};
            svg {
                min-width: 2rem;
            }

            &.success {
                background-color: ${alpha(theme.palette.primary, 0.12)};
                color: ${theme.palette.primary};
            }

            &.error {
                background-color: ${alpha(theme.palette.red, 0.12)};
                color: ${theme.palette.red};
            }

            &.warning {
                background-color: ${alpha(theme.palette.gold, 0.12)};
                color: ${theme.palette.gold};
            }
        }
    `,
);
